import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-scroll';
import PortfolioContext from '../../context/context';
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";

const NavBar = () =>{
    // const { navImg } = useContext(PortfolioContext);
    // const {myimg}= navImg;

    const [isDesktop, setIsDesktop] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        if (window.innerWidth > 769) {
          setIsDesktop(true);
          setIsMobile(false);
        } else {
          setIsMobile(true);
          setIsDesktop(false);
        }
      }, []);
    
    return(
        
            
            <Navbar bg="dark" variant="dark" expand="xl" sticky="top">
            <Navbar.Brand>
                <h1 className="hero-title">
                    <span className="text-color-main">Damodar Subedi</span>
                </h1>
            </Navbar.Brand>
            
                <Navbar.Toggle />
                <Navbar.Collapse>
                <Nav className="ml-auto" style={{marginRight: "20rem"}}>
                    
                    <Link to="hero" smooth duration={1000}>
                        
                        <Nav.Link>Home</Nav.Link>
                    </Link>
                    <br/>
                    <Link to="about" smooth duration={1000}>
                        
                        <Nav.Link>About</Nav.Link>
                    </Link>
                    <br/>
                    <Link to="contact" smooth duration={1000}>
                    
                        <Nav.Link>Contact</Nav.Link>
                    </Link>
                    <br/>
                    <Link to="projects" smooth duration={1000}>
                    
                        <Nav.Link>Projects</Nav.Link>
                    </Link>
                    <br/>
                    <Link to="footer" smooth duration={1000}>
                    
                        <Nav.Link>Social Media</Nav.Link>
                    </Link>
                    <br/>

                    
                   
                </Nav>
                
                </Navbar.Collapse>
            </Navbar>
           
       
    );
};

export default NavBar;

